import { LineDelveTypes } from './index.model'

export const getLineDelveDetails = (data: any) => ({
  type: LineDelveTypes.GET_LINE_DELVE_DETAILS,
  data,
})

export const resetLineDelveDetails = () => ({
  type: LineDelveTypes.RESET_LINE_DELVE_DETAILS,
})

export const removeGranteeEmail = (data: any) => ({
  type: LineDelveTypes.REMOVE_GRANTEE_EMAIL,
  data,
})

export const setLineDeleveDetails = (data: any) => ({
  type: LineDelveTypes.SET_LINE_DELVE_DETAILS,
  data,
})

export const getDeviceListData = (data: any) => ({
  type: LineDelveTypes.GET_DEVICE_LIST,
  data,
})

export const deactivateLineAction = (data: any) => ({
  type: LineDelveTypes.DEACTIVATE_LINE,
  data,
})

export const successDeactivateLine = (data: any) => ({
  type: LineDelveTypes.SUCCESS_DEACTIVATE_LINE,
  data,
})

export const removeGranteeSuccess = (data: any) => ({
  type: LineDelveTypes.REMOVE_GRANTEE_SUCCESS,
  data,
})

export const setDeviceList = (data: any) => ({
  type: LineDelveTypes.SET_DEVICE_LIST,
  data,
})

export const removeGranteeFail = () => ({
  type: LineDelveTypes.REMOVE_GRANTEE_FAIL,
})

export const setLoading = (data: any) => ({
  type: LineDelveTypes.SET_LOADING,
  data,
})

export const resetAttempts = () => ({
  type: LineDelveTypes.RESET_ATTEMPTS,
})

export const getPrimaryDevice = (data: any) => ({
  type: LineDelveTypes.GET_PRIMARY_DEVICE,
  data,
})

export const setPrimaryDevice = (data: any) => ({
  type: LineDelveTypes.SET_PRIMARY_DEVICE,
  data,
})

export const setPairedLine = (data: any) => ({
  type: LineDelveTypes.SET_PAIRED_LINE,
  data,
})

export const getPairedLine = (data: any) => ({
  type: LineDelveTypes.GET_PAIRED_LINE,
  data,
})

export const filterLineDelveDetails = (data: any) => ({
  type: LineDelveTypes.FILTER_LINE_DELVE_DETAILS,
  data,
})

export const updateError = (data: any) => ({
  type: LineDelveTypes.UPDATE_ERROR,
  data,
})
